import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propArrayShape, propBool, propFunc, propOneOf, propShape, propStr, } from '../../../../../../../helpers/custom-prop-types';
import FolderTableHead from './FolderTableHead';
import FolderTableRow from './FolderTableRow';
import FolderTableSkeleton from './FolderTableSkeleton';
const FolderTable = (props) => {
    const { folderNamePopperOptions, loading, onClickRow, onClickSort, order, rows, searchText, sort, } = props;
    if (loading) {
        return (_jsx(FolderTableSkeleton, { onClickSort: onClickSort, order: order, sort: sort }));
    }
    return (_jsxs("table", Object.assign({ className: 'mypage_slide_table' }, { children: [_jsx(FolderTableHead, { onClickSort: onClickSort, order: order, sort: sort }), _jsx("tbody", { children: rows.length > 0 ? (rows.map((row) => (_jsx(FolderTableRow, { folderNamePopperOptions: folderNamePopperOptions, item: row, onClickRow: onClickRow }, row.id)))) : (_jsx("tr", Object.assign({ className: 'data_row row' }, { children: _jsx("td", Object.assign({ className: 'col empty_col', colSpan: 3 }, { children: searchText
                            ? '該当する検索結果がありません'
                            : 'フォルダはまだありません' })) }))) })] })));
};
FolderTable.propTypes = {
    folderNamePopperOptions: propShape().isRequired,
    loading: propBool().isRequired,
    onClickRow: propFunc().isRequired,
    onClickSort: propFunc().isRequired,
    order: propOneOf(['asc', 'desc']),
    rows: propArrayShape().isRequired,
    searchText: propStr(),
    sort: propOneOf(['name', 'updatedAt']),
};
FolderTable.defaultProps = {
    order: 'asc',
    searchText: '',
    sort: 'name',
};
export default FolderTable;
